<template>
  <v-layout :class="{'custom-spacing' : searchObject.searchResult}" wrap align-start fill-height>
    <v-flex
      v-for="comp in layoutComps"
      :key="comp.name"
      xs12
      sm4
      :md3="isWide(comp)"
      :md2="!isWide(comp)"
    >
      <component
        :is="comp.name"
        v-bind="comp.props"
        @on-search-clicked="$emit('on-search-clicked')"
      />
    </v-flex>

    <v-flex xs12 sm4 md1>
      <search-go-button
        :class="{'disabled-state' : searchObject.loading}"
        @on-search-clicked="$emit('on-search-clicked')"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from 'vuex'
import SearchAddressInput from './components/SearchAddressInput.vue'
import PriceRangeSelector from './components/PriceRangeSelector.vue'
import BedBathInput from './components/bedBathInput/BedBathInput.vue'
import PetOptionSelect from './components/PetOptionSelect.vue'
import PropertyTypeSelect from './components/propertyType/PropertyTypeSelect.vue'
import SearchGoButton from './components/SearchGoButton.vue'

export default {
  components: {
    SearchAddressInput,
    PriceRangeSelector,
    BedBathInput,
    PetOptionSelect,
    PropertyTypeSelect,
    SearchGoButton
  },

  props: {
    layoutComps: {
      type: Array,
      required: true
    }
  },

  computed: {
    ...mapState('common', ['searchObject'])
  },

  methods: {
    isWide(comp) {
      return (
        comp.name === 'search-address-input'
      )
    }
  }
}
</script>
